import { FileStatus } from '@/types/embed';

export const isFileStatusProcess = (status: FileStatus) => {
  return status === 'process' || status === 'crawled';
};

export const isFileStatusReady = (status: FileStatus) => {
  return status === 'ready';
};

export const isFileStatusFail = (status: FileStatus) => {
  return status === 'fail' || status === 'exceeded';
};

export const isFileStatusInvalid = (status: FileStatus) => {
  return status === 'invalid';
};
